module.exports = __webpack_public_path__ + "img/item7.3d8f11f2.png";